export const getAbsoluteUrl = (url: string | undefined, origin: string) => {
  if (!url) {
    return ''
  }

  try {
    return new URL(url, origin).href
  } catch (_error) {
    return url
  }
}

export const getOpenGraphType = (routeName: string | null | undefined) => {
  switch (routeName) {
    case 'products-_id':
      return 'product'
    case 'actions-__id':
    case 'news-__id':
      return 'article'
    default:
      return 'website'
  }
}
